module.exports = __webpack_public_path__ + "static/tech1-212f89443c825dc1e46fe5000adbdca6.jpg";